<template>
    <div class="content-page">
        <div class="container-fluid add-form-list">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <div class="header-title">
                                <h4 class="card-title">Scan a QR code</h4>
                            </div>
                        </div>
                        <div class="card-body">
                            <form @submit.prevent="send">
                                <div class="row">
                                     
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Code *</label>
                                            <input v-model="payload.code" id="code" type="password" class="form-control"  required>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>                                 
                                </div>                            
                                <!-- <button type="submit" class="btn btn-primary mr-2">Save</button>
                                <button type="reset" class="btn btn-danger">reinitialiser</button> -->
                            </form>
                        </div>
                    </div>
                    
                </div>
            </div>
            <!-- Page end  -->
        </div>
        <div class="vld-parent">
                <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
            </div>
    </div>
      
</template>
<script>
import axios from 'axios'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import {URL_API} from '@/config'
import Swal from 'sweetalert2'
export default {
    components: {
            Loading
    },
    data(){
        return{
            payload: {
                code : ''
            },
            isLoading: false,
            fullPage: true,
            request :0,
            timer:null
        }
    },
    methods: {
        onDecode () {
            const app = this
            console.log(this.payload);
            app.isLoading = true
            
            app.request = 1
            console .log('code', this.payload);
            axios.post(URL_API+'urgency-ticket', app.payload)
            .then(function (reponse){
                app.isLoading = false
                console.log('reponse', reponse);
                if (reponse.data.status == true) {
                    app.request = 1
                    Swal.fire('Successful', reponse.data.message, 'success')
                }else{
                    Swal.fire('Failure', reponse.data.message, 'error')
                }
                app.payload.code = ''
                document.getElementById("code").focus();
               app.request = 0
               //clearInterval(this.timer)

            })
            .catch(function (error){
                console.log('error', error);
                app.request = 0
            })
        },
  /* send(){
      const app = this
      console.log('hshs',this.payload.code)
    //   clearInterval(this.timer)

    //   this.timer =  setTimeout(() => {
          if (this.request == 0) {
                app.onDecode()
            }
    //   }, 500);
      
  }, */
  send() {
    setTimeout(() => {
       this.onDecode()
    }, 3000);
  },
  mounted () {
      document.getElementById("code").focus();
  }
}
}
</script>
<style>
.qr{
    height: 150px;
    width: 150px;
    margin: auto;
}
</style>